export default {
  type: 'doc',
  content: [
    {
      type: 'table',
      attrs: { layout: 'default', __autoSize: true },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    { text: 'Team', type: 'text', marks: [{ type: 'strong' }] }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: "@mention names or link to your team's space"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Timeline',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'Use /date to quickly add the date range for these OKRs'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Related pages',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1 },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'Add links to past OKRs or any other key documents'
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    { type: 'paragraph' },
    {
      type: 'paragraph',
      content: [
        {
          type: 'placeholder',
          attrs: {
            text: 'Plot out each objective and the expected key results in the table below. Put each objective in its own row, add objective owners, and type /status to add the score.'
          }
        }
      ]
    },
    {
      type: 'table',
      attrs: { layout: 'full-width' },
      content: [
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Objectives',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Key results',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    { text: 'Owner', type: 'text', marks: [{ type: 'strong' }] }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Partner with',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Expected EoQ key result score',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableHeader',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Current status',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 3, colwidth: [256.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'e.g., Create a delightful and helpful experience in every single user interaction moment'
                      }
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Owner:',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    },
                    {
                      type: 'placeholder',
                      attrs: { text: '@mention owner' }
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'End-of-quarter objective score:',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    },
                    {
                      type: 'status',
                      attrs: {
                        color: 'neutral',
                        style: 'bold',
                        text: '0.0-1.0'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'Decrease iOS "launch to send first message" time from average 20 seconds to 8 seconds.'
                      }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    { type: 'placeholder', attrs: { text: '@mention owner' } }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: { text: '@mention partners' }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'status',
                      attrs: { color: 'green', style: 'bold', text: '1.0' }
                    }
                  ]
                }
              ]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Month 1',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      type: 'placeholder',
                      attrs: {
                        text: 'We are 1 month into the quarter and have reduced average time from 20 to 18 seconds (10% reduction). We are confident we can find more ways to achieve our goal of 8 seconds (60% reduction) by the end of the quarter.'
                      }
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Month 2',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [{ type: 'placeholder', attrs: { text: '...' } }]
                },
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Month 3',
                      type: 'text',
                      marks: [{ type: 'strong' }]
                    }
                  ]
                },
                {
                  type: 'paragraph',
                  content: [{ type: 'placeholder', attrs: { text: '...' } }]
                }
              ]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 3, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 3, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        },
        {
          type: 'tableRow',
          content: [
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [204.8] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [102.4] },
              content: [{ type: 'paragraph' }]
            },
            {
              type: 'tableCell',
              attrs: { colspan: 1, rowspan: 1, colwidth: [256.0] },
              content: [{ type: 'paragraph' }]
            }
          ]
        }
      ]
    },
    {
      type: 'panel',
      attrs: { panelType: 'info' },
      content: [
        {
          type: 'paragraph',
          content: [
            {
              text: 'For OKR pro tips from Atlassian teams visit:',
              type: 'text'
            },
            {
              text: 'https://www.atlassian.com/team-playbook/plays/okrs',
              type: 'text',
              marks: [
                {
                  type: 'link',
                  attrs: {
                    href: 'https://www.atlassian.com/team-playbook/plays/okrs'
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  version: 1
};
